import axios from 'axios';

// Production'da Render backend URL'ini kullan
// Development'ta proxy kullanılacak (package.json'da tanımlı)
const API_URL = process.env.REACT_APP_API_URL || '';

// Axios default ayarları
if (API_URL) {
  axios.defaults.baseURL = API_URL;
}

// Token varsa her istekte ekle
const token = localStorage.getItem('token');
if (token) {
  axios.defaults.headers.common['Authorization'] = `Bearer ${token}`;
}

export default axios;

